import { useQuery } from "@tanstack/react-query";
import { usersService } from "../services";

export const useUsersQuery = (isActive?: boolean) =>
	useQuery({
		queryKey: ["users", isActive],
		queryFn: () => usersService.getUsersAll(isActive),
	});
